<template>
  <div class="p-0" style="width: 100%; height: 100%; display: flex; flex-direction: column; min-height: 0px;">

    <v-card class="rounded-lg mb-2 pa-2" elevation="1">
      <v-row align="start" justify="space-between">

        <v-col cols="12" md="8" class="d-flex align-center">
          <v-avatar color="deep-purple lighten-4" size="60" class="mr-6">
            <span class="deep-purple--text text--darken-2 text-h5 font-weight-bold">{{displayNameAbreviation}}</span>
          </v-avatar>

          <div>
            <h1 class="text-h5 font-weight-medium mb-1">{{displayMita+ ' - Monatsübersicht ' +monthName + ', ' + date.split('-')[0]}}</h1>
            <div class="subtitle-1 grey--text text--darken-1 mb-3 d-flex align-center">
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-domain</v-icon>
                Kostenstelle: &nbsp;<b>{{' ' + displayKost}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-account-multiple</v-icon>
                Mitarbeitergruppe: &nbsp;<b>{{' ' + displayMigr}}</b>
              </v-chip>
              <v-chip class="mr-2" color="grey lighten-4" text-color="grey darken-3" label>
                <v-icon left small>mdi-calendar-range</v-icon>
                Eintrittsdatum: &nbsp;<b>{{' ' + displayEntryDate}}</b>
              </v-chip>
            </div>

            <!--div class="d-flex flex-wrap" style="gap: 8px">
            </div-->
          </div>
        </v-col>

        <v-col cols="12" md="4" class="d-flex justify-md-end">
          <v-sheet
              color="deep-purple lighten-5"
              class="rounded-lg pa-4"
              width="100%"
              max-width="300"
          >
            <div class="d-flex justify-space-between mb-2 text-body-2">
              <span>VP-Intern</span>
              <span class="font-weight-bold">{{displayVpIntern}}</span>
            </div>
            <div class="d-flex justify-space-between text-body-2">
              <span>VP-Extern</span>
              <span class="font-weight-bold">{{displayVpExtern}}</span>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>

    <v-row class="mb-2" style="height: 320px; flex: 0">

      <v-col cols="4" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="primary" class="mr-2">mdi-beach</v-icon>
            Urlaub
            <v-btn
                elevation="2"
                x-small
                class="ml-auto"
                style="margin-right: 8px"
                @click="queryDetails('holiday')"
            >Details</v-btn>
            <v-icon small color="green darken-2"
                    @click="newHolGranted = (holGranted+'').replace('.', ',');
                            newHolPrevYear = (holPrevYear+'').replace('.', ',');
                            showHolliday = true">mdi-pencil</v-icon>
          </v-card-title>

          <v-card-text class="d-flex align-center mt-2">
            <div class="mr-6 text-center">
              <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="10"
                  :value="(holSaldo/(holGranted + holPrevYear))*100"
                  :color="'green darken-2'"
                  :background-color=" holSaldo >= 0 ? 'grey lighten-3' : 'error'"
              >
                <div class="d-flex flex-column align-center">
                  <span class="text-h5 font-weight-bold" :class="{
                    'green--text': holSaldo >= 0,
                    'text--darken-2': holSaldo >= 0,
                    'error--text': holSaldo < 0
                  }">{{displayNumber(holSaldo, '')}}</span>
                  <span class="caption text-uppercase grey--text">Saldo</span>
                </div>
              </v-progress-circular>
            </div>

            <div style="width: 100%">
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Vortrag Vorjahr</span>
                <span  class="font-weight-bold">{{displayNumber(holPrevYear, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Anspruch laufend</span>
                <span  class="font-weight-bold">{{displayNumber(holGranted, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="grey--text text--darken-1">verbraucht</span>
                <span class="font-weight-bold">{{displayNumber(holUsed, 'Tage')}}</span>
              </div>
              <v-divider class="mb-2 border-dark"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="black--text font-weight-bold text--darken-1">Saldo</span>
                <span class="font-weight-bold" :class="{
                    'green--text': holSaldo >= 0,
                    'text--darken-2': holSaldo >= 0,
                    'error--text': holSaldo < 0
                  }">{{displayNumber(holSaldo, 'Tage')}}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="4" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="amber darken-2" class="mr-2">mdi-clock-time-four-outline</v-icon>
            Überstunden
            <v-btn
                elevation="2"
                x-small
                class="ml-auto"
                style="margin-right: 8px"
                @click="queryDetails('ueb')"
            >Details</v-btn>
            <v-icon small color="green darken-2"
                    @click="newUebPrevYear = (ueb_prev_year+'').replace('.', ',');
                            showUeb = true">mdi-pencil</v-icon>
          </v-card-title>
          <v-card-text class="d-flex align-center mt-2">
            <div class="mr-6 text-center">
              <v-progress-circular
                  :rotate="-90"
                  :size="100"
                  :width="10"
                  :value="(ueb_saldo/(ueb_performed + ueb_prev_year))*100"
                  :color="'green darken-2'"
                  :background-color=" ueb_saldo >= 0 ? 'grey lighten-3' : 'error lighten-1'"
              >
                <div class="d-flex flex-column align-center">
                  <span class="text-h5 font-weight-bold" :class="{
                    'green--text': ueb_saldo >= 0,
                    'text--darken-2': ueb_saldo >= 0,
                    'error--text': ueb_saldo < 0
                  }">{{displayFloat(ueb_saldo)}}</span>
                  <span class="caption text-uppercase grey--text">Saldo</span>
                </div>
              </v-progress-circular>
            </div>

            <div style="width: 100%">
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">Vortrag Vorjahr</span>
                <span  class="font-weight-bold">{{displayFloat(ueb_prev_year, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between mb-2 text-body-2">
                <span class="grey--text text--darken-1">aufgebaut</span>
                <span  class="font-weight-bold">{{displayFloat(ueb_performed, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="grey--text text--darken-1">abgebaut</span>
                <span class="font-weight-bold">{{displayFloat(ueb_used, 'Stunden')}}</span>
              </div>
              <v-divider class="mb-2 border-dark"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span class="black--text font-weight-bold text--darken-1">Saldo</span>
                <span class="font-weight-bold" :class="{
                    'green--text': ueb_saldo >= 0,
                    'text--darken-2': ueb_saldo >= 0,
                    'error--text': ueb_saldo < 0
                  }">{{displayFloat(ueb_saldo, 'Stunden')}}</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4" md="4">
        <v-card class="rounded-lg fill-height pa-2" elevation="1">
          <v-card-title class="text-body-1 font-weight-medium pb-2">
            <v-icon color="error" class="mr-2">mdi-timeline-clock</v-icon>
            Sonstige Zeiten
            <v-icon small color="green darken-2" class="ml-auto"
                    @click="changeOthers = JSON.parse(JSON.stringify(others_settings)); showChangeOthers = true;">mdi-wrench</v-icon>
          </v-card-title>

          <v-card-text class="pt-4">
            <div>
              <div class="d-flex justify-space-between text-body-2">
                <span>Krankheitstage</span>
                <strong>{{displayNumber(others_values.sickdays, 'Tage')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Befreiung</span>
                <strong>{{displayNumber(others_values.exemptions, 'Tage')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Fehlstunden</span>
                <strong>{{displayFloat(others_values.absences, 'Stunden')}}</strong>
              </div>
              <v-divider class="mb-2"></v-divider>
              <div class="d-flex justify-space-between text-body-2">
                <span>Fernbleiben</span>
                <strong>{{displayNumber(others_values.leaves, 'Tage')}}</strong>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-card class="rounded-lg" elevation="1" style="height: 100%; max-height: 100%">
      <v-card-title class="text-subtitle-1 font-weight-bold px-6 pt-5">
        Übersicht sonstige

        <v-btn
            elevation="2"
            small
            class="ml-auto"
            style="margin-right: 8px"
            @click="sheetMode = !sheetMode"
        >{{ sheetMode ? 'Tabellen-Ansicht' : 'Lohnzettel-Ansicht' }}</v-btn>
        <v-icon small color="green darken-2" v-if="!sheetMode"
                @click="changeTable = JSON.parse(JSON.stringify(table_settings)); showChangeTable = true;">mdi-wrench</v-icon>
      </v-card-title>
      <div
          ref="topScroll"
          class="scroll-sync top-scroll"
          @scroll="syncScroll('top')"
          v-if="!sheetMode"
      >
        <div :style="{ width: tableWidth + 'px' }" class="dummy-content"></div>
      </div>
      <v-simple-table id="printable-area"  class="px-2 pb-2"
                      fixed-header ref="vuetifyTable" v-if="!sheetMode">
        <template v-slot:default>
          <thead>
          <tr style="background: lightgrey; border: 2px solid rgba(0,0,0,0.42)">
            <th class="text-left font-weight-medium pl-6 font-weight-bold black--text  table-style" style="white-space: nowrap; background: rgba(241,241,241); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">Typ</th>
            <th class="text-center font-weight-medium pl-6 font-weight-bold black--text" style="background: rgba(241,241,241); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">⌀</th>
            <th v-for="index in numberDaysInMonth" :key="index" class="text-center caption text-uppercase font-weight-bold black--text pointer" @click="queryMitaDay(index)" style="background: rgba(241,241,241); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">
              {{ index }}
            </th>
            <th class="text-center font-weight-bold black--text font-weight-bold" style="background: rgba(241,241,241,0.95); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12); border-left: thin solid rgba(0, 0, 0, 0.12)">Summe</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in tableData" :key="i" class="hover-row" :class="{'table-divider': i === 2, 'table-divider-l': i <= 2 }" >
            <td class="font-weight-medium pl-6  table-style" style="border-left: thin solid rgba(0, 0, 0, 0.12); white-space: nowrap;">{{ truncateString(item.name) }}</td>
            <td class="font-weight-medium pl-6" style="border-left: thin solid rgba(0, 0, 0, 0.12)">{{ getLohnUnit(item.access, item.type) }}</td>
            <td v-for="(val, index) in item.values" :key="index" class="text-right">
              <span v-if="val === 0" class="grey--text text--lighten-2">—</span>
              <span v-else :class="{
                    'green--text': val >= 0 && i === 2,
                    'text--darken-2': val >= 0 && i === 2,
                    'error--text': val < 0 && i === 2,
                    'font-weight-medium': i === 2,
                  }" class="pointer" @click="queryMitaDay(index+1)">{{ (val.toFixed(2)+ '').replace('.', ',') }}</span>
            </td>
            <td class="text-right font-weight-bold" style="" :class="{
                    'green--text': sumArray(item.values) >= 0 && i === 2,
                    'text--darken-2': sumArray(item.values) >= 0 && i === 2,
                    'error--text': sumArray(item.values) < 0 && i === 2
                  }">{{ (sumArray(item.values).toFixed(2)+ '').replace('.', ',') }}</td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-simple-table
          class="timesheet-table"
          v-else
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th rowspan="2" class="text-center fixed-width">Datum</th>

            <th colspan="2" class="text-center group-header">Rufbereitschaft</th>

            <th colspan="3" class="text-center group-header">Arbeitszeit</th>

            <th colspan="2" class="text-center group-header">Arbeiteinsatz</th>
            <th colspan="3" class="text-center group-header">Abwesenheiten</th>

            <th rowspan="2" class="text-center">Soll-<br>zeit</th>
            <th rowspan="2" class="text-center">Ist-<br>zeit</th>
            <th rowspan="2" class="text-center">Wochen-<br>saldo</th>
            <th rowspan="2" class="text-center">Monats-<br>saldo</th>
          </tr>
          <tr>
            <th class="text-center sub-header">Von</th>
            <th class="text-center sub-header">Bis</th>

            <th class="text-center sub-header">Von</th>
            <th class="text-center sub-header">Bis</th>
            <th class="text-center sub-header">Std.</th>

            <th class="text-center sub-header">Zeitz.</th>
            <th class="text-center sub-header">Rund.</th>
            <th class="text-center sub-header">Urlaub</th>
            <th class="text-center sub-header">Üb. abgebaut</th>
            <th class="text-center sub-header">Fehlzeit</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="index in numberDaysInMonth" :key="index" :class="{'row-weekend' : tableData[0].values[index-1] <= 0.0 && currentMita}">
            <td class="font-weight-medium pl-6  table-style text-center pointer" style="border-left: thin solid rgba(0, 0, 0, 0.12)" @click="queryMitaDay(index)">
              {{ "" + getWeekday(index)+ " " + String(index).padStart(2, '0') + "." + date.split('-')[1]  }}</td>
            <td class="text-center">
              <span v-if="!rbs[index-1]" class="grey--text text--lighten-2">—</span>
              <span v-for="(val, i) in rbs[index-1]" :key="index + 'rb_von' + i" v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{val.von}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="!rbs[index-1]" class="grey--text text--lighten-2">—</span>
              <span v-for="(val, i) in rbs[index-1]" :key="index + 'rb_bis' + i" v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{val.bis}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="!user_times[index-1]" class="grey--text text--lighten-2">—</span>
              <span v-for="(val, i) in user_times[index-1]" :key="index + 'ut_von' + i" v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{val.von}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="!user_times[index-1]" class="grey--text text--lighten-2">—</span>
              <span v-for="(val, i) in user_times[index-1]" :key="index + 'ut_bis' + i" v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{val.bis}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="!user_times[index-1]" class="grey--text text--lighten-2">—</span>
              <span v-for="(val, i) in user_times[index-1]" :key="index + 'ut_ist' + i" v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(val.ist)}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="zz[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(zz[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="roundings[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(roundings[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="holidays[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(holidays[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="ueb_abgebaut[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(ueb_abgebaut[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="fehls[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(fehls[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="tableData[0].values[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(tableData[0].values[index-1])}}
              </span>
            </td>
            <td class="text-center">
              <span v-if="tableData[1].values[index-1] === 0.0" class="grey--text text--lighten-2">—</span>
              <span v-else  class="grey--text text--darken-3 d-block pointer" @click="queryMitaDay(index)">
                {{displayHoures(tableData[1].values[index-1])}}
              </span>
            </td>
            <td @click.stop="" class="" style="background-color: #f5f5f5 !important;" v-if="calendar_weeks.find(item => item.start_day === index)" :rowspan="calendar_weeks.find(item => item.start_day === index).end_day - calendar_weeks.find(item => item.start_day === index).start_day + 1">
              <v-col class="justify-end" style="height: 100%; padding: 8px 0px; display: flex;justify-content: flex-end;flex-direction: column;">
                <span class="text-center font-weight-bold" style="display: block">{{'KW ' + calendar_weeks.find(item => item.start_day === index).calendar_week_number}}</span>
                <span class="text-right font-weight-medium" >{{'S: ' + displayHoures(calculateSolls(calendar_weeks.find(item => item.start_day === index)))}}</span>
                <span class="text-right font-weight-medium" >{{'A:  ' + displayHoures(calculateIsts(calendar_weeks.find(item => item.start_day === index)))}}</span>
                <v-divider style="margin-top: 8px; margin-bottom: 12px;"></v-divider>
                <span class="text-right font-weight-medium" >{{displayHoures(calculateIsts(calendar_weeks.find(item => item.start_day === index)) - calculateSolls(calendar_weeks.find(item => item.start_day === index)))}}</span>
              </v-col>
            </td>
            <td @click.stop="" class="" style="background-color: #f5f5f5 !important;" v-if="index === 1" :rowspan="numberDaysInMonth">
              <v-col class="justify-end" style="height: 100%; padding: 8px 0px; display: flex;justify-content: flex-end;flex-direction: column;">
                <span class="text-right font-weight-medium" >{{'S: ' + displayHoures(sumArray(tableData[0].values).toFixed(2)+ '')}}</span>
                <span class="text-right font-weight-medium" >{{'A:  ' + displayHoures(sumArray(tableData[1].values).toFixed(2)+ '')}}</span>
                <v-divider style="margin-top: 8px; margin-bottom: 12px;"></v-divider>
                <span class="text-right font-weight-medium" >{{displayHoures(sumArray(tableData[1].values) - sumArray(tableData[0].values))}}</span>
              </v-col>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-dialog
        v-model="showHolliday"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Urlaubsbuchung</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-text-field
              label="Urlaubsvortrag"
              v-model="newHolPrevYear"
              suffix="Tage"
          ></v-text-field>
          <v-text-field
              label="Urlaubsanspruch"
              v-model="newHolGranted"
              suffix="Tage"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showHolliday = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="
              !newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0
              || !newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0"
              v-on:click.stop="changeSaldo(parseFloat(newHolPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')), parseFloat(newHolGranted.replace(/[^0-9,-.]/g, '').replace(',','.')), -1)"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showUeb"
        :max-width="'300px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Überstundenbuchung</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-text-field
              label="Überstundenvortrag"
              v-model="newUebPrevYear"
              suffix="Tage"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showUeb = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="
              !newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')
              || parseFloat(newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')) < 0"
              v-on:click.stop="changeSaldo(-1, -1, parseFloat(newUebPrevYear.replace(/[^0-9,-.]/g, '').replace(',','.')))"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showChangeOthers"
        :max-width="'450px'"
        persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Einstellung: Sonstige Zeiten</span>
        </v-card-title>
        <v-card-text style="padding: 12px 28px 20px;">
          <v-autocomplete
              v-model="changeOthers.sickdays"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Krankheitstage"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.exemptions"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Befreiung"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.absences"
              :items="pe02Fehls"
              chips
              deletable-chips
              label="Fehlstunden"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
          <v-autocomplete
              v-model="changeOthers.leaves"
              :items="pe05Fehls"
              chips
              deletable-chips
              label="Fernbleiben"
              multiple
              item-text="name"
              item-value="bis_id"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showChangeOthers = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="others_settings = changeOthers; showChangeOthers = false; saveSettings()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showChangeTable"
        :max-width="'450px'"
        persistent
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Einstellung: Übersicht sonstige</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-list>
            <v-list-item-group
                v-model="changeTable"
                multiple
            >
              <template v-for="(item, i) in possibleSettings">
                <v-divider
                    v-if="!item"
                    :key="`divider-${i}`"
                ></v-divider>

                <v-list-item
                    v-else
                    :key="`item-${i}`"
                    :value="item"
                    active-class="primary--text text--accent-4"
                >
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name + ' (' + getLohnUnit(item.access, item.type) + ')'"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox
                          :input-value="active"
                          color="primary accent-4"
                      ></v-checkbox>
                    </v-list-item-action>
                  </template>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showChangeTable = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="table_settings = changeTable; showChangeTable = false; saveSettings()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showHolidayDetails"
        :max-width="'450px'"
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Details: Urlaub</span>
          <v-col></v-col>
          <v-btn
              icon
              @click="showHolidayDetails = false; showCalendar('holiday')"
          >
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-row style="padding: 0 8px !important; margin-bottom: 0px">
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2"
                  v-text="'Datum'"
                  style="height: 36px; padding-left: 8px; padding-right: 0px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'Urlaub verbraucht'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
          </v-row>
          <v-list three-line>
            <template v-for="(item, index) in holidayOverviews">
              <v-divider
                  v-if="index !== 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-subheader
                  v-if="index === 0 || holidayOverviews[index-1].month !== item.month"
                  :key="months[item.month]"
                  v-text="months[item.month]"
                  style="height: 36px; padding-left: 8px"
              ></v-subheader>

              <v-list-item
                  :key="item.date"
              >
                  <v-list-item-title class="pointer" @click="queryMitaDay(parseInt(item.date.split[2]))" v-html="item.date.split('-').reverse().join('.')"></v-list-item-title>
                  <v-list-item-title class="text-center pointer" @click="queryMitaDay(parseInt(item.date.split[2]))" v-html="displayNumber(item.amount, 'Tage')"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showHolidayDetails = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showUebDetails"
        :max-width="'450px'"
        scrollable
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Details: Überstunden</span>
          <v-col></v-col>
          <v-btn
              icon
              @click="showUebDetails = false; showCalendar('ueb')"
          >
            <v-icon>mdi-calendar-month-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 50vh">
          <v-row style="padding: 0 20px !important; margin-bottom: 0px !important; ">
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2"
                  v-text="'Datum'"
                  style="height: 36px; padding-left: 8px; padding-right: 0px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'aufgebaut'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
            <v-col class="p-0">
              <v-subheader
                  class="font-weight-bold text--darken-2 text-center"
                  v-text="'abgebaut'"
                  style="height: 36px; padding-left: 36px"
              ></v-subheader>
            </v-col>
          </v-row>
          <v-list three-line>
            <template v-for="(item, index) in uebOverviews">
              <v-divider
                  v-if="index !== 0"
                  :key="index"
                  style="margin: 4px"
              ></v-divider>
              <v-subheader
                  v-if="index === 0 || uebOverviews[index-1].month !== item.month"
                  :key="months[item.month]"
                  v-text="months[item.month]"
                  style="height: 36px; padding-left: 8px"
              ></v-subheader>

              <v-list-item
                  :key="item.date"
              >
                  <v-list-item-title class="pointer" @click="queryMitaDay(parseInt(item.date.split[2]))" v-html="item.date.split('-').reverse().join('.')"></v-list-item-title>
                  <v-list-item-title class="text-center pointer" @click="queryMitaDay(parseInt(item.date.split[2]))" v-html="displayFloat(item.sum_pos, 'Std.')"></v-list-item-title>
                  <v-list-item-title class="text-center pointer" @click="queryMitaDay(parseInt(item.date.split[2]))" v-html="displayFloat(item.sum_neg, 'Std.')"></v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              v-on:click.stop="showUebDetails = false"
          >
            Schließen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <calendar-dialog @event-clicked="queryMitaDay(0, $event)" ref="calendarDialog" :date="date" :holiday-overviews="holidayOverviews" :ueb-overviews="uebOverviews" @show-list="showList"></calendar-dialog>
    <user-day-overview ref="dayOverview" :date="dayOverviewDate" :overview="dayOverview" @goto-day="$router.push('/zeitkontrolle/zeiterfassung?user='+currentMita+'&date=' + dayOverviewDate)"></user-day-overview>
  </div>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import CalendarDialog from "@/views/calendar/CalendarDialog.vue";
import UserDayOverview from "@/views/calendar/UserDayOverview.vue";
import {get} from "immutable";

export default {
  name: "AuskunftMonth",
  props: {
    date: {
      type: String,
      default () {
        return new Date().toISOString().substr(0, 10);
      }
    },
    currentMode: {
      type: String,
      default () {
        return "week";
      }
    },
    currentMita: {
      type: String,
      default: () => undefined
    },
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
    mitasFlat: {
      type: Array,
      default: () => []
    },
    holidayLohn: {
      type: String,
      default: ""
    }
  },
  components: {
    CalendarDialog,
    UserDayOverview
  },
  mounted() {
    // 1. Find the Vuetify internal wrapper
    // Access the root DOM element of the component via $el
    const rootElement = this.$refs.vuetifyTable.$el;

    // Vuetify 2 puts the scrollable part in this class
    this.tableWrapper = rootElement.querySelector('.v-data-table__wrapper');

    // 2. Add the scroll listener manually to that wrapper
    if (this.tableWrapper) {
      this.tableWrapper.addEventListener('scroll', () => {
        this.syncScroll('table');
      });

      // Calculate initial width
      this.calculateWidth();
    }

    window.addEventListener('resize', this.calculateWidth);
    if (this.currentMita) {
      this.queryData()
    }
  },
  beforeDestroy() {
    if (this.tableWrapper) {
      this.tableWrapper.removeEventListener('scroll', this.syncScroll);
    }
    window.removeEventListener('resize', this.calculateWidth);
  },
  watch: {
    date: function (newDate) {
      if (this.currentMita) {
        this.queryData()
      } else {
        this.ueb_performed =  0;
        this.ueb_performed_month =  0;
        this.ueb_used = 0;
        this.ueb_used_month = 0;
        this.ueb_prev_year = 0;
        this.ueb_saldo = 0;
        this.holGranted = 0;
        this.holUsed = 0;
        this.holUsedMonth = 0;
        this.holPrevYear = 0;
        this.holSaldo = 0;
        this.rbs =  [];
        this.user_times =  [];
        this.roundings =  [];
        this.zz = [];
        this.calendar_weeks = [];
        this.holidays = [];
        this.fehls = [];
        this.ueb_abgebaut = [];
        this.tableData = [
          {
            name: 'Soll-Stunden',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
          {
            name: 'Ist-Stunden',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
          {
            name: 'Saldo',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
        ];
      }
    },
    currentMita: function (newDate) {
      if (this.currentMita) {
        this.queryData()
      } else {
        this.ueb_performed =  0;
        this.ueb_performed_month =  0;
        this.ueb_used = 0;
        this.ueb_used_month = 0;
        this.ueb_prev_year = 0;
        this.ueb_saldo = 0;
        this.holGranted = 0;
        this.holUsed = 0;
        this.holUsedMonth = 0;
        this.holPrevYear = 0;
        this.holSaldo = 0;
        this.rbs =  [];
        this.user_times =  [];
        this.roundings =  [];
        this.zz = [];
        this.calendar_weeks = [];
        this.holidays = [];
        this.fehls = [];
        this.ueb_abgebaut = [];
        this.tableData = [
          {
            name: 'Soll-Stunden',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
          {
            name: 'Ist-Stunden',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
          {
            name: 'Saldo',
            values: new Array(this.numberDaysInMonth).fill(0)
          },
        ];
      }
    },
  },
  computed: {
    monthName() {
      let month = this.date.split('-')[1];
      return this.months[parseInt(month) - 1];
    },
    numberDaysInMonth() {
      let date = new Date(this.date);
      return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    },
    displayMita() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.name : "Kein Mitarbeiter ausgewählt";
    },
    displayId() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.bis_id : "000000";
    },
    displayMigr() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.migr : "";
    },
    displayKost() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? mita.kost : "";
    },
    displayEntryDate() {
      let mita = this.getCurrentMita(this.currentMita);
      return mita ? (mita.start_date ? mita.start_date : 'Nicht gesetzt') : "";
    },
    displayNameAbreviation() {
      let mita = this.getCurrentMita(this.currentMita);
      if (mita && mita.name) {
        let names = mita.name.split(' ');
        if (names.length >= 2) {
          return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
        } else if (names.length === 1) {
          return names[0].charAt(0).toUpperCase();
        }
      }
      return "";
    },
    displayVpIntern() {
      let mita = this.getCurrentMita(this.currentMita);
      if (!mita) {
        return "";
      }
      let vp = mita.price_int;
      vp = vp.replace('EUR', '').replace('EU', '').replace('.', ',').replace('€', '').replace(',', '.').trim();
      // bring to 2 digits after comma
      vp = parseFloat(vp).toFixed(2);
      return (vp + '').replace('.', ',') + " €";
    },
    displayVpExtern() {
      let mita = this.getCurrentMita(this.currentMita);
      if (!mita) {
        return "";
      }
      let vp = mita.price_ext;
      vp = vp.replace('EUR', '').replace('EU', '').replace('.', ',').replace('€', '').replace(',', '.').trim();
      // bring to 2 digits after comma
      vp = parseFloat(vp).toFixed(2);
      return (vp + '').replace('.', ',') + " €";
    },
    pe02Fehls() {
      return this.possible_lohns.filter(item => item.lohn_type === 'F' && item.lohn_usage_type === 'PE02')
    },
    pe05Fehls() {
      return this.possible_lohns.filter(item => item.lohn_type === 'F' && item.lohn_usage_type === 'PE05')
    },
    possibleSettings() {
      let settings = [];
      for (let i = 0; i < this.possible_lohns.length; i++) {
        let item = this.possible_lohns[i];
        let res = {
          name: item.name,
        }
        switch (item.lohn_type) {
          case 'F':
            if (item.lohn_usage_type === 'PE05' && item.unit === '2') {
              let second = {
                name: item.name,
                type: "fehl_02",
                access: item.bis_id
              };
              settings.push(second);
            }
            res.type = item.lohn_usage_type === 'PE02' ? "fehl_02" : "fehl_05";
            res.access = item.bis_id;
            break;
          case 'ZZ':
            res.type = "zz";
            res.access = item.access;
            break;
          default:
            res.type = "sur";
            res.access = item.access;
            break;
        }
        settings.push(res);
      }
      settings.push({
        name: 'Rufbereitschaften',
        type: 'rb',
        access: 'rb_access'
      })
      settings.push({
        name: 'Urlaub verbraucht',
        type: 'hol_02',
        access: 'hol_access'
      })
      settings.push({
        name: 'Urlaub verbraucht',
        type: 'hol_05',
        access: 'hol_access'
      })
      settings.push({
        name: 'Überstunden geleistet RB',
        type: 'ueb_rb',
        access: 'ueb_rb_access'
      })
      settings.push({
        name: 'Überstunden geleistet',
        type: 'ueb',
        access: 'ueb_access'
      })
      return settings.sort((a, b) => a.name.localeCompare(b.name));
    }
  },
  data: () => ({
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    tableData: [
      {
        name: 'Soll-Stunden',
        access: '',
        type: 'fehl_02',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: 'Ist-Stunden',
        access: '',
        type: 'fehl_02',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
      {
        name: 'Saldo',
        access: '',
        type: 'fehl_02',
        values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      },
    ],
    ueb_performed: 0,
    ueb_performed_month: 0,
    ueb_used: 0,
    ueb_used_month: 0,
    ueb_prev_year: 0,
    ueb_saldo: 0,
    holGranted: 0,
    holUsed: 0,
    holUsedMonth: 0,
    holPrevYear: 0,
    holSaldo: 0,

    showHolliday: false,
    newHolPrevYear: '0',
    newHolGranted: '0',

    showUeb: false,
    newUebPrevYear: '0',

    possible_lohns: [],
    others_settings: {
      sickdays: [],
      exemptions: [],
      absences: [],
      leaves: [],
    },
    table_settings: [],
    changeTable: [],
    showChangeTable: false,
    changeOthers: {
      sickdays: [],
      exemptions: [],
      absences: [],
      leaves: [],
    },
    others_values: {
      sickdays: 0,
      exemptions: 0,
      absences: 0,
      leaves: 0,
    },
    showChangeOthers: false,
    tableWidth: 0,
    tableWrapper: null, // Store reference to the specific internal DOM node
    isSyncing: false, // Prevents infinite scroll loops

    holidayOverviews: [],
    uebOverviews: [],
    showHolidayDetails: false,
    showUebDetails: false,

    // details
    rbs: [],
    user_times: [],
    roundings: [],
    zz: [],
    calendar_weeks: [],
    holidays: [],
    fehls: [],
    ueb_abgebaut: [],
    sheetMode: false,

    dayOverviewDate: new Date().toISOString().substr(0, 10),
    dayOverview: {
      user_day: {
        soll: 0.0,
        ist: 0.0,
        valence: 0.0,
        has_rufbereitschaft: false,
      },
      time_blocks: [],
      time_surcharges: 0.0,
      ueb_performed: 0.0,
      roundings: 0.0,
      rounding_entries: [],
      rb: "",
      surcharges: [],
    },
  }),
  methods: {
    queryMitaDay(day = 0, date = '') {
      this.showUebDetails = false;
      this.showHolidayDetails = false;
      this.dayOverviewDate = this.date.split('-')[0] + '-' + this.date.split('-')[1] + '-' + (day < 10 ? '0' + day : day);
      if (date !== '') {
        this.dayOverviewDate = date;
      }
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/user_day/' + mita.bis_id + "?date=" + this.dayOverviewDate
      ).then(this.responseOkGetDayOverview, this.responseError)
    },
    responseOkGetDayOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.dayOverview = response.body;
        this.$refs.dayOverview.openDialog();
      } else {
        window.location = Redirect_500;
      }
    },
    getWeekday(day) {
      const date = new Date(parseInt(this.date.split('-')[0]), parseInt(this.date.split('-')[1]) - 1, day);
      return this.weekdays[date.getDay()]; // 0 (Sunday) to 6 (Saturday)
    },
    calculateSolls(calendarWeek) {
      let res = 0.0;
      for (let i = calendarWeek.start_day - 1; i < calendarWeek.end_day; i++) {
        res += this.tableData[0].values[i];
      }
      return res;
    },
    calculateIsts(calendarWeek) {
      let res = 0.0;
      for (let i = calendarWeek.start_day - 1; i < calendarWeek.end_day; i++) {
        res += this.tableData[1].values[i];
      }
      return res;
    },
    queryDetails(detail_type) {
      this.showLoader();
      let mita = this.getCurrentMita(this.currentMita);
      if (detail_type === 'holiday') {
        this.$http.get(
            Server_URL_ZK + '/zk/overview_detail/holiday/' + mita.bis_id + "?year=" + this.date.split('-')[0]
        ).then(this.responseHolidayDetails, this.responseError)
      } else {
        this.$http.get(
            Server_URL_ZK + '/zk/overview_detail/ueb/' + mita.bis_id + "?year=" + this.date.split('-')[0]
        ).then(this.responseOkUebDetails, this.responseError)
      }
    },
    showList(mode) {
      if(mode === 'holiday') {
        this.showHolidayDetails = true;
      } else {
        this.showUebDetails = true;
      }
    },
    showCalendar(mode) {
      if(mode === 'holiday') {
        this.$refs.calendarDialog.openDialog('holiday');
      } else {
        this.$refs.calendarDialog.openDialog('ueb');
      }
    },
    responseHolidayDetails(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.holidayOverviews = response.body;
        this.$refs.calendarDialog.openDialog('holiday');
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkUebDetails(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.uebOverviews = response.body;
        this.$refs.calendarDialog.openDialog('ueb');
      } else {
        window.location = Redirect_500;
      }
    },
    get,
    calculateWidth() {
      if (this.tableWrapper) {
        // Use scrollWidth of the internal wrapper
        this.tableWidth = this.tableWrapper.scrollWidth;
      }
    },
    syncScroll(source) {
      if (this.isSyncing) return;
      this.isSyncing = true;

      const top = this.$refs.topScroll;
      // Use the stored internal wrapper instead of the component ref
      const bottom = this.tableWrapper;

      if (source === 'top') {
        bottom.scrollLeft = top.scrollLeft;
      } else {
        top.scrollLeft = bottom.scrollLeft;
      }

      window.requestAnimationFrame(() => {
        this.isSyncing = false;
      });
    },
    truncateString(str) {
      let maxLength = 35;
      if (str.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
      }
      return str;
    },
    getLohnUnit(access, type) {
      switch (type) {
        case 'fehl_02':
        case 'zz':
        case 'ueb':
        case 'ueb_rb':
        case 'hol_02':
        case 'rb':
          return 'Std.';
        case 'fehl_05':
        case 'hol_05':
          return 'Tage';
        case 'sur':
          let lohn = this.possible_lohns.find(item => item.access === access);
          if (lohn) {
            if (lohn.lohn_usage_type === 'PE02') {
              return 'Std.';
            } else if (lohn.lohn_usage_type === 'PE05' && lohn.unit === '2') {
              return 'Tage';
            } else {
              return 'Stk.';
            }
          } else {
            return 'Std.';
          }
      }
    },
    saveSettings() {
      this.showLoader();
      let req = {
        others_setting: this.others_settings,
        table_settings: this.table_settings.sort((a, b) => a.name.localeCompare(b.name))
      }
      this.$http.post(
          Server_URL_ZK + '/zk/overview_year_setting', req
      ).then((reponse) => {
        let mita = this.getCurrentMita(this.currentMita);
        this.$http.get(
            Server_URL_ZK + '/zk/overview_month/' + mita.bis_id + "?year=" + this.date.split('-')[0] + "&month=" + this.date.split('-')[1]
        ).then(this.responseOkGetOverview, this.responseError)
      }, this.responseError);
    },
    changeSaldo(holPrevYear, holGranted, uebPrevYear) {
      let req = {
        hol_prev_year: holPrevYear,
        hol_entitled: holGranted,
        ueb_prev_year: uebPrevYear
      }
      this.showHolliday = false;
      this.showUeb = false;
      this.showLoader();
      let mita = this.getCurrentMita(this.currentMita);
      this.$http.post(
          Server_URL_ZK + '/zk/overview_year/' + mita.bis_id + "?year=" + this.date.split('-')[0], req
      ).then(this.responseOkTrap, this.responseError);
      if (holPrevYear >= 0) {
        this.holPrevYear = holPrevYear;
      }
      if (holGranted >= 0) {
        this.holGranted = holGranted;
      }
      if (uebPrevYear >= 0) {
        this.ueb_prev_year = uebPrevYear;
      }
      // recalc saldo
      this.holSaldo = this.holPrevYear + this.holGranted - this.holUsed;
      this.ueb_saldo = this.ueb_prev_year + this.ueb_performed - this.ueb_used;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    queryData(){
      let mita = this.getCurrentMita(this.currentMita);
      this.showLoader();
      this.$http.get(
          Server_URL_ZK + '/zk/overview_month/' + mita.bis_id + "?year=" + this.date.split('-')[0] + "&month=" + this.date.split('-')[1]
      ).then(this.responseOkGetOverview, this.responseError)
    },
    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        let data = response.body;
        this.ueb_performed = data.ueb_performed;
        this.ueb_performed_month = data.ueb_performed_month;
        this.ueb_used = data.ueb_used;
        this.ueb_used_month = data.ueb_used_month;
        this.ueb_prev_year = data.ueb_prev_year;
        this.ueb_saldo = data.ueb_saldo;
        this.holGranted = data.holGranted;
        this.holUsed = data.holUsed;
        this.holUsedMonth = data.holUsedMonth;
        this.holPrevYear = data.holPrevYear;
        this.holSaldo = data.holSaldo;
        this.possible_lohns = data.possible_lohns;
        this.others_settings = data.others_settings;
        this.others_values = data.others_values;
        this.table_settings = data.table_settings;
        this.tableData[0].values = data.soll;
        this.tableData[1].values = data.ist;
        this.tableData[2].values = data.saldo;
        for (let i = 0; i < this.table_settings.length; i++) {
          this.tableData[3+i] = {
            name: this.table_settings[i].name,
            access: this.table_settings[i].access,
            type: this.table_settings[i].type,
            values: data.table_times[i] ? data.table_times[i] : new Array(this.numberDaysInMonth).fill(0)
        }
        }
        this.rbs = data.rbs;
        this.user_times = data.user_times;
        this.roundings = data.roundings;
        this.zz = data.zz;
        this.calendar_weeks = data.calendar_weeks;
        this.holidays = data.holidays;
        this.fehls = data.fehls;
        this.ueb_abgebaut = data.ueb_abgebaut;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
      if (response.status === 200) {
      } else {
        window.location = Redirect_500;
      }
    },

    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    displayNumber(num, unit) {
      if (num === 1) {
        // singular, remove trailing e if exists
        unit = unit.replace(/e(n)?$/i, '');
      }
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    displayFloat(num, unit = '') {
      num = parseFloat(num).toFixed(2);
      return (num + '').replace('.', ',') + ' ' + unit;
    },
    displayHoures(num) {
      if (!num) {
        return '';
      }
      let isNegative = num < 0;
      num = Math.abs(num);
      let hours = Math.floor(num);
      let minutes = (Math.round((num - hours) * 60) + '').padStart(2, '0');
      if (isNegative) {
        hours = '-' + hours;
      }
      return `${hours}:${minutes}`;
    },
    sumArray(arr) {
      return arr.reduce((a, b) => a + b, 0);
    }
  }

}
</script>

<style scoped>
/* Custom styling to ensure the table looks clean */
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.75rem !important;
  color: #757575 !important;
}

/* Light hover effect */
.hover-row:hover {
  background-color: #f5f5f5 !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 32px !important;
}

.table-divider {
  border-bottom: solid 2px #7c7c7c !important;
  border-top: solid 2px #7c7c7c !important;
}

.table-divider-l {
  border-left: solid 2px #7c7c7c !important;
  border-right: solid 2px #7c7c7c !important;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 20px; /* Needed for scrollbar visibility */
}

.dummy-content {
  height: 1px;
}


/* 1. Target both the Top Dummy Scroll and the Vuetify Table Wrapper */
.top-scroll,
::v-deep .v-data-table__wrapper {
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #90A4AE #CFD8DC; /* thumb color, track color */
}

/* 2. WebKit Browsers (Chrome, Edge, Safari) */

/* The Scrollbar container */
.top-scroll::-webkit-scrollbar,
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px; /* Height for horizontal scrollbar */
  width: 10px;  /* Width for vertical scrollbar */
}

/* The Track (background) */
.top-scroll::-webkit-scrollbar-track,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #CFD8DC; /* Light grey track */
  border-radius: 4px;
}

/* The Thumb (the moving handle) */
.top-scroll::-webkit-scrollbar-thumb,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #90A4AE; /* Darker grey handle */
  border-radius: 4px; /* Rounded corners */
  border: 2px solid #CFD8DC; /* Creates a 'padding' effect around the thumb */
}

/* Hover effect for the thumb */
.top-scroll::-webkit-scrollbar-thumb:hover,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #607D8B; /* Darken on hover */
}

/* --- Layout Styles (From previous step) --- */
.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  /* Match the height defined in ::-webkit-scrollbar height + a little buffer if needed */
  height: 14px;
}
.dummy-content {
  height: 1px;
}

.table-style {
  position: sticky;
  left: 0;
  z-index: 6 !important;
  background-color: white;
}

</style>

<style scoped>
/* Table Border Styling to match the strict grid look */
.timesheet-table >>> table {
  border-collapse: collapse;
}

.timesheet-table >>> th,
.timesheet-table >>> td {
  border: 1px solid #e0e0e0;
  padding: 0 8px !important;
}

/* Header Styling */
.group-header {
  background-color: #f5f5f5;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}

.sub-header {
  font-size: 0.75rem;
  color: #666;
}

/* Row Coloring */
.row-weekend {
  background-color: #ffff99 !important; /* Yellow */
}

.row-weekend:hover {
  background-color: #ffff66 !important;
}

.row-holiday {
  background-color: #ffcccc !important; /* Light Red */
}

.row-holiday:hover {
  background-color: #ffaaaa !important;
}

/* Column Width Adjustments */
.fixed-width {
  width: 80px;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  text-decoration: underline;
  text-decoration-style: solid;
}

</style>
